export default "__VITE_ASSET__iOvSELQt__"